import { createAction } from 'redux-actions'

export const CHECK_VERSION_REQUEST = 'CHECK_VERSION_REQUEST'
export const checkVersionRequest = createAction<void>(CHECK_VERSION_REQUEST)

export const CHECK_VERSION_SUCCESS = 'CHECK_VERSION_SUCCESS'
export const checkVersionSuccess = createAction<number>(CHECK_VERSION_SUCCESS)
